const getters = {
  isAdmin: state => {
    return state.authUser && (state.authUser.role === 'admin' || state.authUser.role === 'superadmin')
  },
  isLagerAdmin: state => {
    return state.authUser && state.authUser.role === 'lageradmin'
  },
  isUser: state => {
    return state.authUser && state.authUser.role === 'user'
  },
  isFrontdesk: state => {
    return state.authUser && state.authUser.role === 'frontdesk'
  },
  isNotUser: (state, getters) => {
    return getters.isAdmin || getters.isLagerAdmin
  },
  isNotFrontdesk: (state, getters) => {
    return getters.isNotUser || getters.isUser
  }
}

export default getters
